<template>
  <div class="page" :style="{paddingTop: !isWechatBrowser ? '44px' : 0}">
    <w-navbar nav_title="AI看相" v-show="!isWechatBrowser"></w-navbar>
    <img src="https://files.wondercv.com/m/ai/home-result-bg.png" class="page-bg" :style="{top: !isWechatBrowser ? '44px' : 0}"/>
    <img src="https://files.wondercv.com/m/ai/homeTitle.png" alt="" class="title">
    <img src="https://files.wondercv.com/m/ai/subtitle.png" class="subtitle"/>
    <swiper :space-between="50" :options="swiperOption" v-if="swiperOption">
      <swiper-slide v-for="item in 3" :key="item">
        <div style="width: 100%;">
          <img :src="`https://files.wondercv.com/m/ai/type${item}.png`" style="width: 100%"/>
        </div>
      </swiper-slide>
    </swiper>
    <input type="file" id="file" accept="image/*"  v-show="false" ref="file" @change="handleSubmit"/>
<!--    <p style="color: #fff"> 请上传一张人物五官清晰的照片吧</p>-->
    <div class="sub-btn" @click="handleClickInput">
      上传照片，测一测
    </div>
    <p class="ps">即刻邂逅命中注定的工作机会</p>
    <w-loading :show-text="true" v-show="showLoading"/>
  </div>
</template>

<script>
  import {loginMixin, envMixin} from "../../assets/js/mixin/global";
  import WNavbar from "../../components/global/w-navbar"
  import { ai } from "../../api/api-list/index"
  import WLoading from "../../components/global/w-loading"
  import {componentsMixin} from "../../assets/js/mixin/components";
  export default {
    name: "AiIndex",
    mixins: [loginMixin, envMixin, componentsMixin],
    components: {
      WNavbar,
      WLoading
    },
    data(){
      return{
        swiperOption: null,
        showLoading: false
      }
    },
    async mounted() {
      await this.loginByWx()
      window.sessionStorage.removeItem("aiData")
      setTimeout(()=>{
        this.$route.meta.shareByWx('和上千万求职者形象匹配', { title: '不知道自己适合做什么？试试大数据看相！', imgUrl: 'https://files.wondercv.com/m/ai/logo.png'},process.env.VUE_APP_HOST + '/ai/faces')
      },1000)
      console.log(window.outerHeight > 700 ? '1.198' : '1.5')
      this.swiperOption = {
        loop: true, // 无限循环
        slidesPerView: window.outerHeight > 700 ? '1.198' : '1.5',
        centeredSlides: true,
        spaceBetween: '2%',
        loopAdditionalSlides: 100,
      }
      this.$forceUpdate()
    },
    methods: {
      handleClickInput() {
        try{
          let file = document.querySelector("#file")
          if (this.alreadyLogged) {
            if(file){
              file.value = ""
              file.click()
            }else{
            }
          } else {
            this.needLogin()
          }
        }catch (e) {
          alert(JSON.stringify(e))
        }
      },
      async handleSubmit(e){
       try{
         let file = e.target.files[0]
         let params = new FormData();
         params.append('file',file)
         this.showLoading = true
         let res = await this.$api.ai.getAiFaces(params)
         if(res.code === 1000) {
           let firstUse = window.localStorage.getItem("first-use")
           let profession_ids = []
           if(!firstUse){
             let intentions = await this.$api.intention.getIntentionNew()
             if(intentions.code === 1000){
               profession_ids = intentions.data.profession_ids
               window.localStorage.setItem("first-use", 'true')
             }
           }
           if(profession_ids.length === 0){
             profession_ids = res.data.profession_id
           }
           let res1 = await  this.$api.ai.getAiFacesReport({ profession_ids, salary_id: res.data.salary_id || '' })
           if (res1.code === 1000){
             let {face_description, level1, level2, level3, top_achievement,industry_role_model, stats_salary} = res1.data
             let res2 = await this.$api.HrApi.getJobListBySearch({from: 0, size: 3, jdflag: 2 ,keyword:`${level3 || ''} ${level2 || ''} ${level1 || ''}` })
             if(res2.code === 1000){
               this.showLoading = false
               window.sessionStorage.setItem("aiData",JSON.stringify({...res1.data, jobsList: res2.data.jobs, img: res.data.img}))
               this.$router.push({path: "/ai/result"})
             } else {
               this.showLoading = false
               this.$createToast({
                 time: 3000,
                 type: 'txt',
                 txt: res2.message || res2.msg
               }).show()
             }
           } else {
             this.showLoading = false
             this.$createToast({
               time: 3000,
               type: 'txt',
               txt: res1.message || res1.msg
             }).show()
           }
         }else{
           this.showLoading = false
           this.$createToast({
             time: 3000,
             type: 'txt',
             txt: res.message || res.msg
           }).show()
         }
       }catch (e) {
         this.showLoading = false
         this.$createToast({
           time: 3000,
           type: 'txt',
           txt: '服务器正在开小差，请稍后重试！！！'
         }).show()
       }
      }
    }
  }
</script>

<style scoped lang="scss">
  .page{
    background: #190647;
    min-height: 100vh;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 20px;
    .page-bg{
      position: absolute;
      width: 100vw;
      left: 0;
      right: 0;
      z-index: 0;
    }
    .title{
      width: calc( 100vw * (296 / 375));
      position: relative;
      z-index: 1;
      margin: 20px 51px 4px 28px;
    }
    .subtitle{
      width: 282px;
      margin-left: 47px;
      margin-bottom: 21px;
      position: relative;
      z-index: 1;
    }
    .sub-btn{
      width: 313px;
      height: 50px;
      margin: 22px auto 10px;
      background: url("https://files.wondercv.com/m/ai/btn.png");
      text-align: center;
      line-height: 50px;
      background-size: 100%;
      color: #B44200;
      font-size: 20px;
      font-weight: 500;
    }
    .ps{
      text-align: center;
      font-size: 11px;
      font-weight: 400;
      color: #887CA5;
      line-height: 16px;
    }
  }
  /deep/.swiper-slide>div>img{
    transition: all 0.5s;
  }
  /deep/.swiper-slide-prev>div>img{
    transform: scale(0.95);
  }
  /deep/.swiper-slide-next>div>img{
    transform: scale(0.95);
  }
</style>